import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { backgroundNavbar } from './style';
import { Navbar, Row, Col } from 'react-bootstrap';
import { HouseDoor, ListUl, ArrowBarLeft, ArrowBarRight } from 'react-bootstrap-icons';


const BottomNavbar = ({fungsinya, fungsikiri, fungsikanan, fungsikepart, listNovelnya, bukuDipilihnya, partDipilihnya}) => {
  return (
    <Navbar collapseOnSelect fixed='bottom' className={backgroundNavbar} style={{paddingTop: '0px'}}>
      <div className="logo">
          <Row>
          {partDipilihnya - 1 !== 0
          && (
              <Col>
                <Navbar.Brand href="#" onClick={fungsikiri} className="pojokKiri">
                <ArrowBarLeft className="logoBuku" color="white"/>
                </Navbar.Brand>
            </Col>
            )}
            <Col>
                <Navbar.Brand href="#" onClick={fungsikepart} className="pojokKiri">
                <ListUl className="logoBuku" color="white"/>
                </Navbar.Brand>
            </Col>

            <Col>
                <Navbar.Brand href="#" onClick={fungsinya} className="pojokKiri">    
                <HouseDoor className="logoBuku" color="white"/>
                </Navbar.Brand>
            </Col>
            {partDipilihnya !== listNovelnya[bukuDipilihnya-1].jumlahChapter
                 && (
            <Col>
                <Navbar.Brand href="#" onClick={fungsikanan} className="pojokKiri">
                <ArrowBarRight className="logoBuku" color="white"/>
                </Navbar.Brand>
            </Col>
                 )}
        </Row>
    </div>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        
      </Navbar.Collapse>
    </Navbar>
  );
};
export default BottomNavbar;
